import React from 'react';
import { render } from 'react-dom';
import globalStore, { history } from './store';
import Root from './app/components/Root/Root';

import { setAxiosAccessToken } from './axios';
import { handleStateToStorageSync } from './storageAndStoreSync';
import './scss/style.scss';

require('./favicon.ico');

handleStateToStorageSync(globalStore);
setAxiosAccessToken(globalStore);

const appElement = document.getElementById('app');
if (!appElement) {
    throw new Error('Element with ID "app" not found on page');
}

render(<Root store={globalStore} history={history} />, appElement);
